// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { GrowthbookCard } from './GrowthbookCard';

const growthbookCard = EntityCardBlueprint.make({
  name: 'growthbook',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { GrowthbookCard } = await import('./GrowthbookCard');
      return <GrowthbookCard />;
    },
  },
});

export const growthbookCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [growthbookCard],
});
